export class TrendIconViewModel {
  Id?: number = undefined;
  Url: string;
  UrlOff: string;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Url = data["url"];
      this.UrlOff = data["urlOff"];
    }
  }

  static fromJS(data: any): TrendIconViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TrendIconViewModel();
    result.init(data);
    return result;
  }
}
